import React from 'react';
import { useReveal } from '../../hooks/useReveal';
import './WhyEvolve.scss';

const WhyEvolve = () => {
    const [ref, revealed] = useReveal({ threshold: 0.2 });

    return (
        <section className="why-evolve" id="about" ref={ref}>
            <div className={`we-inner ${revealed ? 'is-in' : ''}`}>
                <div className="we-left">
                    <span className="we-eyebrow">Why Evolve Exists</span>
                    <h2 className="we-title">
                        Not a studio.
                        <br />
                        <span className="we-title-accent">A lab.</span>
                    </h2>
                </div>

                <div className="we-right">
                    <p className="we-lead">
                        Technology changes constantly. So do the problems worth solving.
                    </p>
                    <p>
                        Evolve Labs exists to explore ideas, turn promising ones into products,
                        ship them into the real world, and continue improving them long after
                        launch.
                    </p>
                    <p>
                        We identify a problem, experiment until something works, engineer it into
                        a real product, and then let actual usage tell us what it should become
                        next. That loop is the company.
                    </p>
                    <p className="we-kicker">
                        We are not interested in building one product forever. We are interested
                        in building what comes next.
                    </p>

                    <dl className="we-facts">
                        <div>
                            <dt>Founded</dt>
                            <dd>Detroit, USA</dd>
                        </div>
                        <div>
                            <dt>Model</dt>
                            <dd>Owned products</dd>
                        </div>
                        <div>
                            <dt>Focus</dt>
                            <dd>AI, tools, platforms</dd>
                        </div>
                    </dl>
                </div>
            </div>
        </section>
    );
};

export default WhyEvolve;
